import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import Icon, { icons } from '../../../generic/Icon';
import { Link } from '../../../generic/Link';

import styles from './IssueDetailsDrawer.module.less';

/**
 * IssueDetailsDrawerOpenIssueInFullPage is an Icon which is used in
 * the Drawer's buttonSlot. It is an icon which links to the full
 * page version of the issue details.
 */
const IssueDetailsDrawerOpenIssueInFullPage: VoidFunctionComponent = () => {
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails);
  const issueDetailsURL = useSelector(IssuesV2Store.selectors.getIssueDetailsURLFromActiveIssueDetails);

  if (!issueDetails) {
    return null;
  }
  return (
    <Link
      to={issueDetailsURL}
      className={styles.openInFullPageLink}
      openInNewTab
    >
      <Icon icon={icons.expand} />
    </Link>
  );
};

export default IssueDetailsDrawerOpenIssueInFullPage;
